var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import Logo from '@doordash/component-logo';
import { InlineChildren, Text } from '@doordash/design-language';
import * as React from 'react';
import { Link, matchPath } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { PORTAL_ROUTE_PREFIX, HOME_PAGE_PATH } from '../../constants/values';
import { getIsAdmin, getTeamName } from '../../selectors/portal_selector';
import { HeaderRoot, DoorDashLogoContainer, NavLinkWapper, HeaderNavList, } from './HeaderStyles';
import HeaderDropdown from './HeaderDropdown';
import { BaseContainer } from '../Styles/Containers';
import track from '../../utils/track';
import { HeaderTestId } from '../testId';
var HeaderContent = styled(InlineChildren)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 80px;\n"], ["\n  min-height: 80px;\n"])));
export var getHomeClassName = function (pathName) {
    var match = matchPath(pathName, {
        path: HOME_PAGE_PATH,
        exact: true,
        strict: false,
    });
    return !!match;
};
export var getAdminClassName = function (pathName) {
    var match = matchPath(pathName, {
        path: PORTAL_ROUTE_PREFIX + "/admin",
        exact: false,
        strict: false,
    });
    return !!match;
};
export var Header = function (_a) {
    var teamName = _a.teamName, isAdmin = _a.isAdmin, location = _a.location, _b = _a.hideHeaderDropDown, hideHeaderDropDown = _b === void 0 ? false : _b;
    return (React.createElement(HeaderRoot, null,
        React.createElement(BaseContainer, null,
            React.createElement(HeaderContent, { justifyContent: InlineChildren.Justification.SpaceBetween, alignItems: InlineChildren.Alignment.Center },
                React.createElement("div", null,
                    React.createElement(Link, { to: "" + PORTAL_ROUTE_PREFIX },
                        React.createElement(DoorDashLogoContainer, { "data-testid": "LogoContainer" },
                            React.createElement(Logo, { type: Logo.Types.Logomark }))),
                    React.createElement(Text, { color: Text.Colors.SystemGrey60 }, teamName ? "Work Portal for " + teamName : 'Work Portal')),
                React.createElement(HeaderNavList, null,
                    isAdmin && (React.createElement(NavLinkWapper, { isSelected: getAdminClassName(location.pathname) },
                        React.createElement(Link, { to: PORTAL_ROUTE_PREFIX + "/admin", onClick: function () { return track('workportal_click_settings'); } }, "Settings"))),
                    React.createElement(NavLinkWapper, { isSelected: false },
                        React.createElement("a", { href: "https://help.doordash.com/work/s/", target: "_blank", rel: "noopener noreferrer", "data-testid": HeaderTestId.SupportButton }, "Support")),
                    !hideHeaderDropDown && (React.createElement(NavLinkWapper, { isSelected: false },
                        React.createElement(HeaderDropdown, null))))))));
};
export var mapStateToProps = function (state) { return ({
    isAdmin: getIsAdmin(state),
    teamName: getTeamName(state),
}); };
export default connect(mapStateToProps)(Header);
var templateObject_1;
